import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPosts } from "@/lib/api";

/**
 * Latest Posts list.
 * - layout="sidebar" → narrow single-column bulleted list (used in sidebars)
 * - layout="main"   → wider 2-column grid for the main content column
 */
export default function LatestPostsWidget({ layout = "sidebar", limit = 6 }) {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        Promise.all([getPosts("latest"), getPosts("recent")])
            .then(([latest, recent]) => {
                setPosts([...latest, ...recent].slice(0, limit));
            })
            .catch(() => setPosts([]));
    }, [limit]);

    if (layout === "main") {
        return (
            <section
                className="bg-white"
                data-testid="latest-posts-main"
            >
                <h2 className="section-title mb-6">Latest Posts</h2>
                <ul
                    className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-5 font-sofia text-[0.95rem] leading-relaxed list-disc pl-5 marker:text-[#E63B26]"
                >
                    {posts.map((p) => (
                        <li key={p.id} data-testid={`latest-li-${p.slug}`}>
                            <Link
                                to={`/post/${p.slug}`}
                                className="latest-post-link"
                                data-testid={`latest-link-${p.slug}`}
                            >
                                {p.title.length > 60
                                    ? p.title.slice(0, 57) + "..."
                                    : p.title}
                            </Link>{" "}
                            <span className="text-[#1B1B1B]/80">
                                {(p.blurb || "").length > 100
                                    ? (p.blurb || "").slice(0, 97) + "..."
                                    : p.blurb}
                            </span>
                        </li>
                    ))}
                </ul>
            </section>
        );
    }

    return (
        <aside className="bg-white" data-testid="latest-posts-widget">
            <h3 className="section-title text-3xl mb-4">Latest Posts</h3>
            <ul className="space-y-5 font-sofia text-[0.95rem] leading-relaxed list-disc pl-5 marker:text-[#E63B26]">
                {posts.map((p) => (
                    <li key={p.id} data-testid={`latest-li-${p.slug}`}>
                        <Link
                            to={`/post/${p.slug}`}
                            className="latest-post-link"
                            data-testid={`latest-link-${p.slug}`}
                        >
                            {p.title.length > 55
                                ? p.title.slice(0, 52) + "..."
                                : p.title}
                        </Link>{" "}
                        <span className="text-[#1B1B1B]/80">
                            {(p.blurb || "").length > 100
                                ? (p.blurb || "").slice(0, 97) + "..."
                                : p.blurb}
                        </span>
                    </li>
                ))}
            </ul>
        </aside>
    );
}
